// extracted by mini-css-extract-plugin
export default {"tenantName":"tenant-action-modal_tenantName__l3L2Z","pkiButtonPrimary":"tenant-action-modal_pkiButtonPrimary__V3wXm"};